exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date[data-v-d65b29aa]{font-size:1.75rem}.clock-container[data-v-d65b29aa]{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.fa-clock[data-v-d65b29aa]:hover{cursor:pointer}.fa-clock[data-v-d65b29aa]{margin:auto}.gray-clock[data-v-d65b29aa]{color:grey}.red-clock[data-v-d65b29aa]{color:red}.orange-clock[data-v-d65b29aa]{color:orange}.green-clock[data-v-d65b29aa]{color:green}", ""]);

// exports
